import React from 'react';
import { Hero, Testimonials, Problem } from './components/Sections1';
import { Product, Bonuses } from './components/Sections2';
import { Pricing } from './components/Sections3';
import { Guarantee, FAQ, CostOfInaction, Footer } from './components/Sections4';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Testimonials data-id="element-3" />
        <Problem data-id="element-4" />
        <Product data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Pricing data-id="element-7" />
        <Guarantee data-id="element-8" />
        <FAQ data-id="element-9" />
        <CostOfInaction data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}